import { navLinks } from "@/mocks/homeData";

function scrollToId(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Footer() {
  const goSubmit = () => scrollToId("submit");

  return (
    <footer className="bg-accent-500 text-foreground-950" aria-label="页脚">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr]">
          {/* 品牌 */}
          <div>
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollToId("hero");
              }}
              className="flex items-center gap-2.5"
              aria-label="爆料吧 首页"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-foreground-950 text-accent-500">
                <i className="ri-fire-fill text-2xl" aria-hidden="true"></i>
              </span>
              <span className="font-serifsc text-2xl font-black">
                爆料<span className="text-primary-700">吧</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-800">
              吧友投稿入口已开放，支持匿名投稿与图文格式，三步完成发帖爆料。
              吧友在线审核，热门瓜第一时间上首页。你的真实故事，值得一个响亮的声音。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-douban-fill", "ri-tiktok-fill"].map((ic) => (
                <a
                  key={ic}
                  href="#submit"
                  onClick={(e) => {
                    e.preventDefault();
                    goSubmit();
                  }}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-foreground-950/10 transition-colors hover:bg-foreground-950 hover:text-accent-500"
                  aria-label="关注爆料吧"
                >
                  <i className={`${ic} text-lg`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* 快速导航 */}
          <nav aria-label="页脚导航">
            <h4 className="font-serifsc text-base font-bold">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToId(link.id);
                    }}
                    className="inline-flex items-center gap-1.5 text-sm text-foreground-800 transition-colors hover:text-primary-700"
                  >
                    <i className="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 联系方式与投稿 */}
          <div>
            <h4 className="font-serifsc text-base font-bold">投稿与联系</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-800">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" aria-hidden="true"></i>
                tougao@baoliaoba.fans
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line" aria-hidden="true"></i>
                吧友在线审核 · 1-2 小时过审
              </li>
            </ul>
            <button
              type="button"
              onClick={goSubmit}
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 text-sm font-bold text-accent-500 transition-transform hover:scale-105"
            >
              <i className="ri-send-plane-fill" aria-hidden="true"></i>
              进入投稿入口
            </button>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-foreground-950/10 pt-6 text-xs text-foreground-700 sm:flex-row">
          <p>© {new Date().getFullYear()} 爆料吧 · 吃瓜投稿社区 · 匿名投稿请遵守平台规则</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line" aria-hidden="true"></i>
            尊重事实 · 拒绝造谣 · 理性吃瓜
          </p>
        </div>
      </div>
    </footer>
  );
}